<template>
  <container :class="['page-wrapper', 'mb-6']">
    <flex :spacing="3">
      <flex-col :span="24">
        <card>
          <card-text>
            <timeline v-if="roadmap.length" fixed-width>
              <timeline-item v-for="(item, index) in roadmap" :key="index">
                <timeline-item-date x-align="right" v-if="isEven(index)">
                  <h2 v-html="item.date" :class="['text-lg']" />
                  <divider />
                </timeline-item-date>
                <timeline-item-info x-align="left" v-if="!isEven(index)">
                  <card>
                    <card-title :bg-color="item.barBgColor" :bg-color-lightness="item.barBgColorLightness" color="white" v-html="item.date" />
                    <card-text>
                      <list v-if="item.todos && item.todos.length">
                        <list-item v-for="(todo, i) in item.todos" :class="[!todo.to ? 'pointer-events-none' : null]" :key="i" :tag="todo.to ? 'router-link' : 'row'" :to="todo.to">
                          <list-item-avatar v-if="!todo.to">
                            <avatar :bg-color="item.barBgColor" :bg-color-lightness="item.barBgColorLightness" :text="$config.appNameAbbr" />
                          </list-item-avatar>
                          <list-item-content>
                            <list-item-content-title v-html="todo.title" />
                            <list-item-content-sub-title v-if="todo.subTitle" :truncate="false" v-html="todo.subTitle" />
                          </list-item-content>
                          <list-item-icon v-if="todo.to">
                            <icon name="chevron-double-right" />
                          </list-item-icon>
                        </list-item>
                      </list>
                    </card-text>
                  </card>
                </timeline-item-info>
                <timeline-item-bar
                  :icon-color="iconColor"
                  :bar-color="barColor"
                  :bar-width="barWidth"
                  :bar-bg-color="item.barBgColor"
                  :bar-bg-color-lightness="item.barBgColorLightness"
                  :icon="item.icon"
                  :icon-color-lightness="null"
                  :bar-color-lightness="200" />
                <timeline-item-date x-align="left" v-if="!isEven(index)">
                  <h2 v-html="item.date" :class="['text-lg']" />
                  <divider />
                </timeline-item-date>
                <timeline-item-info x-align="left" v-if="isEven(index)">
                  <card>
                    <card-title :bg-color="item.barBgColor" :bg-color-lightness="item.barBgColorLightness" color="white" v-html="item.date" />
                    <card-text>
                      <list v-if="item.todos && item.todos.length">
                        <list-item v-for="(todo, i) in item.todos" :class="[!todo.to ? 'pointer-events-none' : null]" :key="i" :tag="todo.to ? 'router-link' : 'row'" :to="todo.to">
                          <list-item-avatar v-if="!todo.to">
                            <avatar :bg-color="item.barBgColor" :bg-color-lightness="item.barBgColorLightness" text="bcq" />
                          </list-item-avatar>
                          <list-item-content>
                            <list-item-content-title v-html="todo.title" />
                            <list-item-content-sub-title :truncate="false" v-html="todo.subTitle" />
                          </list-item-content>
                          <list-item-icon v-if="todo.to">
                            <icon name="chevron-double-right" />
                          </list-item-icon>
                        </list-item>
                      </list>
                    </card-text>
                  </card>
                </timeline-item-info>
              </timeline-item>
            </timeline>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageRoadmap',
  mixins: [
    methods
  ],
  data () {
    return {
      roadmap: [],
      barWidth: '4px',
      width: '15%',
      barColor: 'gray',
      iconColor: 'white'
    }
  },
  mounted () {
    this.getExternalData('roadmap.json', 'roadmap')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/roadmap.vue